import React, { useContext } from "react";

import { RemixBuilderContext } from "./RemixBuilderContext";

const RemixBuilderSettingsBreadcrumb = (props) => {
  const { options = [], appendLabel } = props;

  const [contextData, builder] = useContext(RemixBuilderContext);

  const StepLabel = (props) => {
    return (
      <div
        onClick={() => builder.goToStep(props.step)}
        data-step={props.step}
        className={`remix-step ${
          contextData.current_step == props.step ? "active" : ""
        }`}
      >
        {props.label}
      </div>
    );
  };

  const ArrowRight = () => {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.66667 4.66675L10 8.00008L6.66667 11.3334"
          stroke="#A5A5A5"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };

  return (
    <React.Fragment>
      {contextData.current_step > 0 && (
        <div className="remix-editor-settings-breadcrumb gap-[8px] 2xl:gap-[15px] text-gray-400 text-xl">
          {options.map((option, index) => (
            <React.Fragment key={`remix-step-${option.step}`}>
              <StepLabel step={option.step} label={option.name} />
              {(index < options.length - 1 || appendLabel) && <ArrowRight />}
            </React.Fragment>
          ))}
          {appendLabel && (
            <div className="remix-step text-gray-400 cursor-default">
              {appendLabel}
            </div>
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default RemixBuilderSettingsBreadcrumb;
